import { Spinner, useToast } from "@chakra-ui/react";
import { apiurl } from "APIURL";
import axios from "axios";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getCertificate } from "redux/slices/certificateSlice";
import { getProfileData } from "redux/slices/userSlice";
import "./style.css";
const Certificate = () => {
  const { formationId } = useAppSelector(getCertificate);
  const [certificateData, setCertificateData] = useState<any>();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const user = useAppSelector(getProfileData);
  const toast = useToast();
  useEffect(() => {
    const getCertificateModel = async (userId: string, formationId: number) => {
      try {
        setLoading(true);
        const res = await axios.get(
          `${apiurl}/certificate/generate?userId=${userId}&formationId=${formationId}`
        );
        //dispatch(setCertificate(res.data))
        console.log(res.data);
        setCertificateData(res.data);
        setLoading(false);
      } catch (error) {
        toast({
          title: "Un erreur rencontré",
          description:
            "Nous n'avons pas pu recevoir votre certificat ,réessayer plus tard",
          status: "error",
          duration: 5000,
        });
        setLoading(false);
      }
    };
    getCertificateModel(user.userId, formationId);
  }, [user.userId, formationId]);
  return (
    <>
      {loading === true ? (
        <Spinner color="brand.500" />
      ) : (
        <div
          style={{ marginTop: 100 }}
          className="container pm-certificate-container"
        >
          <div className="outer-border"></div>
          <div className="inner-border"></div>

          <div className="pm-certificate-border col-xs-12">
            <div className="row pm-certificate-header">
              <div className="pm-certificate-title cursive col-xs-12 text-center">
                <h2>Tunisie Telecome certificat de completion de formation</h2>
              </div>
            </div>

            <div className="row pm-certificate-body">
              <div className="pm-certificate-block">
                <div className="col-xs-12">
                  <div className="row">
                    <div className="col-xs-2"></div>
                    <div className="pm-certificate-name underline margin-0 col-xs-8 text-center">
                      <span className="pm-name-text bold">
                        {certificateData?.formation.title}
                      </span>
                    </div>
                    <div className="col-xs-2"></div>
                  </div>
                </div>

                <div className="col-xs-12">
                  <div className="row">
                    <div className="col-xs-2"></div>
                    <div className="pm-earned col-xs-8 text-center">
                      <span className="pm-earned-text padding-0 block cursive">
                        Achevé par Mr/Mme
                      </span>
                      <span className="pm-earned-text padding-0 block cursive">
                        {certificateData?.user.name +
                          " " +
                          certificateData?.user.surname}
                      </span>
                    </div>
                    <div className="col-xs-2"></div>
                    <div className="col-xs-12"></div>
                  </div>
                </div>

                <div className="col-xs-12">
                  <div className="row">
                    <div className="col-xs-2"></div>
                    <div className="pm-course-title col-xs-8 text-center">
                      <span className="pm-earned-text block cursive">
                        pour completer les cours et les test de certification de
                        $
                        {new Date(
                          certificateData?.formationEnroll.enrollDate
                        ).toLocaleDateString()}{" "}
                        à ${new Date().toLocaleDateString()}
                      </span>
                    </div>
                    <div className="col-xs-2"></div>
                  </div>
                </div>

                <div className="col-xs-12">
                  <div className="row">
                    <div className="col-xs-2"></div>
                    <div className="pm-course-title underline col-xs-8 text-center">
                      <span className="pm-credits-text block bold sans">
                        Tunisie Télécom
                      </span>
                    </div>
                    <div className="col-xs-2"></div>
                  </div>
                </div>
              </div>

              <div className="col-xs-12">
                <div className="row">
                  <div className="pm-certificate-footer">
                    <div className="col-xs-4 pm-certified col-xs-4 text-center">
                      <span className="pm-credits-text block sans"></span>
                      <span className="pm-empty-space block underline"></span>
                      <span className="bold block">
                        Tunisie télécome eLearning 2022-2023
                      </span>
                    </div>
                    <div className="col-xs-4">
                      <img
                        height={50}
                        width={50}
                        src={certificateData?.qrCodeImage}
                      />
                    </div>
                    <div className="col-xs-4 pm-certified col-xs-4 text-center"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Certificate;
